import { useState } from "react";
import { RiEditLine } from "react-icons/ri";
import "./Address.scss";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";

const Address = () => {
  const [isVisibleAddNewAddressForm, setIsVisibleAddNewAddress] =
    useState(false);

  const address = [
    {
      id: 1,
      firstName: "Md",
      lastName: "Firdosh",
      address: "Ajad basti mango",
      city: "Jamshedpur",
      state: "jharkhand",
      pinCode: 818191,
      mobileNo: 1234567890,
    },
  ];

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleAddress = async (payload: any) => {
    console.log("payload", payload);
    toast.success("Address added successfully");
    try {
    } catch (err) {
      toast.error("Error adding address");
      console.error("error", err);
    }
  };

  return (
    <div className="w-full">
      <div className="flex justify-between w-full gap-5 h-fit items-start">
        {/** if no any address added  */}
        {address.length === 0 && (
          <div className="text-center w-4/5">
            No address added yet. Please include one to proceed!
          </div>
        )}
        {/** add new address form  */}
        {isVisibleAddNewAddressForm && (
          <form className="address_form" onSubmit={handleSubmit(handleAddress)}>
            {/* <div className="flex justify-between items-center gap-5">
              <div className="flex flex-col gap-1 input_group">
                <label htmlFor="firstName">First name*</label>
                <input
                  type="text"
                  id="firstName"
                  placeholder="Enter your first name"
                  className="input_field"
                />
              </div>
              <div className="flex flex-col gap-1 input_group">
                <label htmlFor="lastName">Last name*</label>
                <input
                  type="text"
                  id="lastName"
                  placeholder="Enter your last name"
                  className="input_field"
                />
              </div>
            </div> */}
            <div className="flex justify-between items-center gap-5">
              <div className="flex flex-col gap-1 input_group">
                <label htmlFor="street">Street*</label>
                <input
                  type="text"
                  id="street"
                  placeholder="Enter your street"
                  className="input_field"
                  {...register("street", { required: true })}
                />
                <div className="field_error">
                  {errors.street && <div>Street is required</div>}
                </div>
              </div>
              <div className="flex flex-col gap-1 input_group">
                <label htmlFor="city">City*</label>
                <input
                  type="text"
                  id="city"
                  placeholder="Enter your city"
                  className="input_field"
                  {...register("city", { required: true })}
                />
                <div className="field_error">
                  {errors.city && <div>City is required</div>}
                </div>
              </div>
            </div>
            <div className="flex justify-between items-center gap-5">
              <div className="flex flex-col gap-1 input_group">
                <label htmlFor="state">State*</label>
                <input
                  type="text"
                  id="state"
                  placeholder="Enter your state"
                  className="input_field"
                  {...register("state", { required: true })}
                />
                <div className="field_error">
                  {errors.state && <div>State is required</div>}
                </div>
              </div>
              <div className="flex flex-col gap-1 input_group">
                <label htmlFor="zipCode">ZipCode*</label>
                <input
                  type="text"
                  id="zipCode"
                  placeholder="Enter your zip code"
                  className="input_field"
                  {...register("zipCode", { required: true })}
                />
                <div className="field_error">
                  {errors.zipCode && <div>Zip code is required</div>}
                </div>
              </div>
            </div>
            <div className="flex justify-between items-center gap-5">
              <div className="flex flex-col gap-1 input_group">
                <label htmlFor="country">Country*</label>
                <input
                  type="text"
                  id="country"
                  placeholder="Select country"
                  className="input_field"
                  {...register("county", { required: true })}
                />
                <div className="field_error">
                  {errors.county && <div>County is required</div>}
                </div>
              </div>
            </div>

            {/* <div className="flex flex-col gap-1 input_group">
              <label htmlFor="address">Address*</label>
              <input
                type="text"
                id="address"
                placeholder="Enter address"
                className="input_field"
              />
            </div>
            <div className="flex flex-col gap-1 input_group">
              <label htmlFor="city">City*</label>
              <input
                type="text"
                id="city"
                placeholder="Enter city"
                className="input_field"
              />
            </div>
            <div className="flex flex-col gap-1 input_group">
              <label htmlFor="state">State*</label>
              <input
                type="text"
                id="state"
                placeholder="Enter state"
                className="input_field"
              />
            </div>
            <div className="flex flex-col gap-1 input_group">
              <label htmlFor="pincode">Pin code*</label>
              <input
                type="text"
                id="pincode"
                placeholder="Enter pincode"
                className="input_field"
              />
            </div>
            <div className="flex flex-col gap-1 input_group">
              <label htmlFor="mobileNo">Mobile no*</label>
              <input
                type="text"
                id="mobileNo"
                placeholder="Enter mobile no "
                className="input_field"
              />
            </div> */}
            <div className="flex justify-between items-center gap-5 w-full mt-5">
              <div className="add_btn button bg-black py-[10px] px-5 text-white rounded text-[14px]  cursor-pointer wfull">
                <button>Cancel</button>
              </div>
              <div className="add_btn button bg-black py-[10px] px-5 text-white rounded text-[14px]  cursor-pointer wfull">
                <button type="submit">Add address</button>
              </div>
            </div>
          </form>
        )}

        {/* added addresses  */}
        {address.length !== 0 && !isVisibleAddNewAddressForm && (
          <div className="flex justify-between w-[80%] gap-5">
            <div className="border border-[var(--text-gray-color)] rounded py-5 px-3  w-full">
              <div className="flex flex-col gap-2">
                <div className="flex justify-between items-center">
                  <div className="font-medium text-[var(--black-color)] text-[17px]">
                    Firdosh
                  </div>
                  <div className="flex gap-[2px] text-[var(--text-gray-color)] font-medium items-center cursor-pointer text-[14px]">
                    <RiEditLine />
                    Edit
                  </div>
                </div>
                <div className="font-normal text-[var(--text-gray-color)] text-[14px]">
                  jamshedpur Mango Ajad Basti Lorem ipsum dolor, sit amet
                  consectetur adipisicing elit. Accusamus, delectus!,
                  Jharkhand-832110
                </div>
                <div className="font-normal text-[14px] text-[var(--text-gray-color)]">
                  +91 <span>8128009191</span>
                </div>
              </div>
            </div>
            <div className="border border-[var(--text-gray-color)] rounded py-5 px-3  w-full">
              <div className="flex flex-col gap-2">
                <div className="flex justify-between items-center">
                  <div className="font-medium text-[var(--black-color)] text-[17px]">
                    Firdosh
                  </div>
                  <div className="flex gap-[2px] text-[var(--text-gray-color)] font-medium items-center cursor-pointer text-[14px]">
                    <RiEditLine />
                    Edit
                  </div>
                </div>
                <div className="font-normal text-[var(--text-gray-color)] text-[14px]">
                  jamshedpur Mango Ajad Basti Lorem ipsum dolor, sit amet
                  consectetur adipisicing elit. Accusamus, delectus!,
                  Jharkhand-832110
                </div>
                <div className="font-normal text-[14px] text-[var(--text-gray-color)]">
                  +91 <span>8128009191</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {!isVisibleAddNewAddressForm && (
          <div
            className="add_btn button bg-black py-2 px-5 text-white rounded text-[14px]  cursor-pointer w-fit"
            onClick={() => setIsVisibleAddNewAddress((prev) => !prev)}
          >
            <button>Add new address</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Address;
